var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "menu-wrapper" },
    [
      !_vm.item.children || !_vm.item.children.length
        ? [
            _c(
              "el-menu-item",
              {
                attrs: {
                  index: _vm.item.name,
                  disabled:
                    _vm.item.disabled || !_vm.checkVipAllow(_vm.item.vipLevel),
                },
                on: {
                  click: function ($event) {
                    return _vm.goto(_vm.item)
                  },
                },
              },
              [
                _vm._v(
                  _vm._s(
                    _vm.item.meta.title + (_vm.item.disabled ? "(开发中)" : "")
                  ) + " "
                ),
                !_vm.checkVipAllow(_vm.item.vipLevel)
                  ? _c("em", { staticClass: "special" }, [
                      _vm._v("VIP" + _vm._s(_vm.item.vipLevel) + "开启"),
                    ])
                  : _vm._e(),
              ]
            ),
          ]
        : _c(
            "el-submenu",
            {
              ref: "subMenu",
              attrs: { index: _vm.item.name, "popper-append-to-body": "" },
            },
            [
              _c("template", { slot: "title" }, [
                _vm._v(" " + _vm._s(_vm.item.meta.title) + " "),
              ]),
              _vm._l(_vm.item.children, function (child) {
                return _c("nav-item", {
                  key: child.name,
                  staticClass: "nest-menu",
                  attrs: {
                    "is-nest": true,
                    item: child,
                    "project-id": _vm.projectId,
                    "report-id": _vm.reportId,
                  },
                })
              }),
            ],
            2
          ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }